module.exports = __webpack_public_path__ + "static/services-section-1cfe0309f5fc9077ef1a3b2080e21eaf.png";